export const VIEW_AS_EXCLUDE_PREFIXES: string[] = ['https://storage.blazemeter.com'];
